import { DocsNavSection } from './types';

export const DEFAULT_DOC_SLUG = 'introduction-to-agents';

export const docsNavSections: DocsNavSection[] = [
  {
    title: 'Getting Started',
    links: [{ label: 'Signing In', slug: 'signing-in' }],
  },
  {
    title: 'Agents',
    links: [
      { label: 'Introduction to Agents', slug: 'introduction-to-agents' },
      { label: 'Creating an Agent', slug: 'agent-builder' },
      { label: 'Configuring an Agent', slug: 'agent-configuration' },
      { label: 'Integrating an Agent', slug: 'agent-integrations' },
      { label: 'Chatting with an Agent', slug: 'agent-chat' },
      { label: 'Managing Agents', slug: 'managing-agents' },
      { label: 'Agent Conversations', slug: 'agent-conversations' },
      { label: 'Tips for Power Users', slug: 'agent-tips' },
    ],
  },
  {
    title: 'Integrations',
    links: [
      { label: 'Integrations Overview', slug: 'integrations-overview' },
      { label: 'Connectors', slug: 'integration-connectors' },
      { label: 'MCP Servers', slug: 'integration-mcp-servers' },
      { label: 'API Tools', slug: 'integration-apis' },
    ],
  },
  {
    title: 'Skills',
    links: [
      { label: 'Skills Overview', slug: 'skills-overview' },
      { label: 'Creating Skills', slug: 'skills-creating' },
      { label: 'Editing Skills', slug: 'skills-editing' },
    ],
  },
  {
    title: 'Knowledge Base',
    links: [
      { label: 'Knowledge Base Overview', slug: 'knowledge-base-overview' },
      { label: 'Adding Knowledge', slug: 'knowledge-base-content' },
      { label: 'Knowledge Sources', slug: 'knowledge-base-sources' },
    ],
  },
  {
    title: 'Workspace',
    links: [
      { label: 'Projects', slug: 'projects' },
      { label: 'Scheduled Tasks', slug: 'scheduled' },
      { label: 'Library', slug: 'library' },
      { label: 'Dashboards', slug: 'dashboards' },
    ],
  },
  {
    title: 'Account',
    links: [
      { label: 'Usage', slug: 'usage' },
      { label: 'Users and Seats', slug: 'identity-management' },
    ],
  },
  {
    title: 'Release notes',
    links: [{ label: 'Changelog', slug: 'changelog' }],
  },
];
